module.exports = __webpack_public_path__ + "img/jason-WS-v2.af4a617e.jpeg";